<template>
  <div class="page">
    <breadcrumb />
    <div class="top-banner">
      <div class="tb-title">
        <h3 class="sex-title">
          {{ `brand_page.titles.brands` | translate }}
        </h3>
      </div>
      <div class="tb-content">
        <div class="tb-left">
          <p>{{ `brand_page.descriptions.brands` | translate }}</p>
        </div>
        <div class="tb-right">
          <div
            class="store-image hidden"
            :style="{
              backgroundImage: `url()})`
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="isParsed" class="brand-section">
        <div
          class="brand-container"
          v-for="(brandGroup, key) in parsedBrands"
          :key="key"
        >
          <h3 class="brand-key">{{ key }}</h3>
          <div
            v-for="(brand, j) in brandGroup"
            :key="j"
            @click="onBrandClick(brand)"
          >
            <p class="brand">{{ brand }}</p>
          </div>
        </div>
      </div>
      <gyra-spinner v-else />
    </div></div
></template>

<script>
import Breadcrumb from "../components/molecules/breadcrumb";
import { getPossibleFilterValues } from "../services/api";
import GyraSpinner from "../components/atoms/gyra-spinner";
import { mapMutations } from "vuex";
export default {
  name: "BrandPage.vue",
  components: { GyraSpinner, Breadcrumb },
  data() {
    return {
      brands: null,
      parsedBrands: {},
      isParsed: false
    };
  },
  methods: {
    async getBrands() {
      const response = await getPossibleFilterValues("brand");
      if (response.status === 200) {
        this.brands = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    parseBrands() {
      this.brands.forEach(brand => {
        let key;
        if (/^\d/.test(brand)) {
          key = "123";
        } else {
          key = brand[0];
        }

        if (!(key in this.parsedBrands)) {
          this.parsedBrands[key] = [];
        }
        this.parsedBrands[key].push(brand);
      });
      this.isParsed = true;
    },
    onBrandClick(brand) {
      this.setFieldByKeyValue({ key: "brand", value: [brand] });
      this.$router.push({ name: "ProductMap" });
    },
    ...mapMutations({
      setFieldByKeyValue: "filters/setFieldByKeyValue"
    })
  },
  async beforeMount() {
    await this.getBrands();
    this.parseBrands();
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.top-banner {
  min-height: 319px;
  width: 100%;
  background-color: $gyra-grey-lightest;
  padding-top: 23px;

  .tb-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin: 0 $gyra-margin-sides;
    }
  }

  .sex-title {
    font-size: 30px;
    @media (min-width: $gyra-breakpoint-lg) {
      font-size: 50px;
    }
    margin: 0 10px 0 0;
  }
  .emoji {
    font-size: 50px;
  }

  .tb-content {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    @media (min-width: $gyra-breakpoint-xl) {
      flex-direction: row;
    }
  }

  .tb-left {
    margin: 20px 40px 0 $gyra-margin-sides-mobile;
    @media (min-width: $gyra-breakpoint-lg) {
      margin: 40px 40px 0 $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin: 0 40px 0 $gyra-margin-sides;
    }
    p {
      font-size: 12px;
      @media (min-width: $gyra-breakpoint-lg) {
        font-size: 16px;
      }
    }
  }

  .tb-right {
    @media (min-width: $gyra-breakpoint-lg) {
      margin-left: $gyra-margin-sides;
    }
    @media (min-width: $gyra-breakpoint-xl) {
      margin-right: $gyra-margin-sides;
      margin-top: 0;
    }
    margin-top: 20px;
    margin-left: $gyra-margin-sides-mobile;

    .store-image {
      @media (min-width: $gyra-breakpoint-xl) {
        margin-top: -80px;
      }
      @media (min-width: $gyra-breakpoint-sm) {
        height: 280px;
        width: 530px;
      }

      margin-top: 0;
      height: 192px;
      width: 330px;
      border: 1px solid;
      border-radius: 20px;
    }
  }
}

.content {
  min-height: 50vh;
}

.brand-section {
  padding: 35px $gyra-margin-sides-mobile 0 $gyra-margin-sides-mobile;
  @media (min-width: $gyra-breakpoint-md) {
    padding: 35px $gyra-margin-sides 0 $gyra-margin-sides;
  }
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  .brand-container {
    width: 150px;
    @media (min-width: $gyra-breakpoint-md) {
      width: 200px;
    }
    @media (min-width: $gyra-breakpoint-lg) {
      width: 250px;
    }
  }

  .brand-key {
    font-size: 72px;
  }
  .brand {
    font-size: 14px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
.hidden {
  display: none !important;
}
</style>
